<template>
    <!-- 首页 -->
    <div class="home">
        <!-- 系统管理员 99 -->
        <div v-if="role_grade == 99">
            <systemAdminHome></systemAdminHome>
        </div>
        <!-- 系统管理员结束 -->

        <!-- 教联体端首页 96 -->
        <div v-else-if="role_grade == 96">
            <educationHome></educationHome>
        </div>
        <!-- 教联体结束 -->

        <!-- 学校端首页 95 -->
        <div v-else-if="role_grade == 95" class="boss">
            <statistics></statistics>
            <div class="item">
                <echartsData></echartsData>
            </div>
        </div>
        <!-- 教联体结束 -->

        <div v-else-if="role_grade != ''">
            <defaultPage></defaultPage>
        </div>

    </div>

</template>

<script>
import {
    nodesApi, //资源
} from '@/api/index' //接口

import systemAdminHome from '@/components/homePage/systemAdminHomePage/systemAdminHome'//系统管理员端首页-99
import educationHome from '@/components/homePage/educationHomePage/educationHome'//教联体端首页-96

import statistics from '@/components/homePage/schoolHomePage/statistics'
import echartsData from '@/components/homePage/schoolHomePage/echartsData'
import defaultPage from '@/components/homePage/defaultPage'//默认

export default {
    components: {
        statistics,
        echartsData,

        systemAdminHome,//系统管理员 99
        educationHome,//教联体端首页 96
        defaultPage
    },
    data() {
        return {
            role_grade: '',//角色id
        }
    },
    mounted() {
        this.resView() //资源
    },
    methods: {
        // 资源
        async resView() {
            let datas = {
                node_type: 0,
            }
            const res = await this.axios.post(nodesApi, datas);
            if (res.data.code == 1) {
                this.role_grade = res.data.data.role_grade;//角色id
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                });
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.home {
    height: 100%;
}
.boss {
    // overflow-y: auto;
    min-width: 1030px;
    padding: 20px;
    background-color: #eee;
    .item {
        margin-top: 20px;
        // height: 200px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/home.vue